<template id="bs-modal-route">
<div class="modal fade" id="routeCreateModal" tabindex="-1" role="dialog" aria-labelledby="routeCreateModal">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">

			<div class="text-gray-500 font-weight-bold text-uppercase text-base bg-gray-100 px-3 py-25 rounded-top border-bottom">
				<span>Create Route</span>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" data-test="routeModalClose">
		        	<span aria-hidden="true">&times;</span>
		        </button>
			</div>

			<div class="modal-body py-0 px-3">

				<form
					@submit.prevent="submitForm"
					@keydown="form.onKeydown($event)"
					@change="form.onKeydown($event)">	

					<div class="row">
						<div class="d-flex flex-column col-sm-5 pt-3 pb-3">
							<div class="flex-grow-1">

								<alert-errors :form="form">There were some problems with your input.</alert-errors>
								<alert-success :form="form">Your route was saved!</alert-success>
					
								<div class="form-group">
									<label class="mb-0">Route Name <span class="text-gray-500"> - Optional</span></label>
									<input type="text" class="form-control" v-model="form.title" data-test="routeTitle">
								</div>

								<div class="form-group">
									<label class="mb-0">Assigned To <span class="text-gray-500"> - Optional</span></label>
									<div v-if="perms.can_do_everything" class="alert alert-warning mb-1 px-2 py-1 leading-tight text-sm">Be careful assigning routes. User needs to be in the active client group.</div>
									<v-select			                            
			                            label="display_name"
			                            :options="options.user_ids"
			                            :reduce="display_name => display_name.id"
			                            v-model="form.assigned_user_id"
			                            data-test="routeUser"
			                        />
									<small class="form-text text-gray-500">Defaults to you if no user assigned</small>	
								</div>

								<div class="form-group">
									<label class="mb-0">Complete By <span class="text-gray-500"> - Optional</span></label>
									<date-picker 
										readonly="true"
										class="date-picker"
										v-model="form.complete_by"
										:config="config.datePickerOptions"
										data-test="routeEndDate"
									/>
								</div>
							</div>	

							<div class="d-none d-sm-flex button-wrap pt-3 px-3 justify-content-between">
								<span class="btn btn-ghost-secondary" @click="cancelRoute()" data-dismiss="modal" data-test="cancelRouteButton">Cancel</span>
								<button :disabled="form.busy || !newRouteStartObject || !newRouteEndObject" type="submit" class="btn btn-primary" data-test="saveRouteButton">Add Route</button>
							</div>
						</div>



						<div class="route-stops col-sm-7 pb-0 pt-3 bg-gray-200">
							<div class="form-group">
								<label class="mb-0">Route Start</label>
								<v-select
									taggable
									placeholder="Pick existing or type in a new location"
									:options="user.locations"
									:select-on-key-codes="[9, 13]"
									v-model="newRouteStartObject"
									autocomplete="new-password"
									class="mb-1"
									data-test="routeStart"
								>
									<template v-slot:option="option">
										<div class="font-weight-bold">
											{{ option.label }}
										</div>
										<div class="text-sm">{{ option.short_address }}</div>
									</template>
								</v-select>			
							</div>

							<div class="form-group">
								<label class="mb-0">Route End</label>
								<v-select
									taggable
									placeholder="Pick existing or type in a new location"
									:options="user.locations"
									:select-on-key-codes="[9, 13]"
									v-model="newRouteEndObject"
									autocomplete="new-password"
									class="mb-1"
									data-test="routeEnd"
								>
									<template v-slot:option="option">
										<div class="font-weight-bold">
											{{ option.label }}
										</div>
										<div class="text-sm">{{ option.short_address }}</div>
									</template>
								</v-select>			
							</div>	

							<div class="form-group">
								<label class="mb-0">Route Visits</label>

								<div v-if="route_stops && route_stops.length > 25" class="alert alert-warning">
									Routes are limited to 25 visits. Additional visits will not be saved. 
								</div>

								<v-select
									v-if="!route_stops"
									multiple
									label="display_name"
									:options="mappableProviderIds"
									:reduce="display_name => display_name.location_id"
									v-model="form.locations"
									data-test="routeStops"
								>
									<template v-slot:option="option">
										<div class="font-weight-bold">
											{{ option.display_name }}
										</div>
										<div class="text-sm">{{ option.short_address }}</div>
									</template>								
								</v-select>

								<template v-if="save_physicians_first">
									<div class="alert alert-warning px-25 py-2">
										The following physicians will be added to the system when the route is created.
									</div>
									<img v-if="in_progress" class="center-me" src="/images/loading-color.svg">
									<ol v-else type="1">
										<li v-for="route_stop in route_stops" class="mb-2">
											<div class="leading-tight font-weight-bold">{{ route_stop.display_name }}</div>
											<div class="text-sm text-gray-700">{{ route_stop.location[0].short_address }}</div>
										</li>
									</ol>									
								</template>
								<ol v-else type="1" class="mt-2" data-test="routeVisitsPreset">
									<li v-for="route_stop in route_stops" class="mb-2">
										<div class="leading-tight font-weight-bold">{{ route_stop.display_name }}</div>
										<div class="text-sm text-gray-700">{{ route_stop.short_address }}</div>
									</li>
								</ol>
								<small class="text-gray-500">Visits missing complete locations will not be saved</small>						
							</div>

							<div class="d-sm-none d-flex form-group justify-content-between button-wrap p-3 bg-white">
								<span class="btn btn-ghost-secondary" @click="cancelRoute()" data-dismiss="modal">Cancel</span>
								<button :disabled="form.busy" type="submit" class="btn btn-primary">Add Route</button>
							</div>							
						</div>



					</div>
				</form>
			</div>
		</div>
	</div>
</div>
</template>


<script>

	import { mapGetters, mapState } from 'vuex';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';

	export default {
		components: {
			HasError,
			AlertError,
			AlertErrors,
			AlertSuccess,
			Form,
		},

		data() {
			return {
				route_stops: null,
				save_physicians_first: false,
				in_progress: false,
				newRouteStartObject: false,
				newRouteEndObject: false,
				form: {},
			}
		},

		created() {
			this.createForm();
			//this.$store.dispatch('fetchMappablePhysicianIds');
		},

		mounted() {
			let self = this;
			window.goToRoute = function(route_id) {
				self.$router.push({ name: 'routes.show', params: { id: route_id } });
			};

			this.$root.$on('build_route_modal', data => {
				this.route_stops = data.route_stops;
				this.save_physicians_first = data.save_physicians_first;
			});
		},

		methods: {
			cancelRoute() {
				this.createForm();
				this.route_stops = [];
			},

			createForm() {
				this.form = new Form({
					title: '',
					assigned_user_id: this.user.id,
					complete_by: null,
					route_start: '',
					route_start_other: '',
					route_end: '',
					route_end_other: '',
					locations: [],
				});
			},

			submitForm() {
				if (this.save_physicians_first) {
					this.savePhysiciansThenRoute();
				}
				else {
					if (this.route_stops) {
						this.form.locations = this.route_stops.map(item => item.location_id).slice(0,25);
					}
					this.submitRoute();
				}
			},

		    submitRoute() { 
		    	this.form.post('/api/routes/store').then(({ data }) => {
					//return the new route
					this.$root.$emit('route_added', data);

					//forgive me, for I have sinned
					jQuery('#routeCreateModal').modal('hide');

					//reset the form
					this.route_stops = null;
					this.newRouteStartObject = false;
					this.newRouteEndObject = false;					
					this.createForm();

					Swal.fire({
					    toast: true,
					    position: 'top-end',
					    showConfirmButton: false,
					    timer: 4000,
					    icon: 'success',
					    title: 'Route saved',
					    html: '<div><a href="#" onclick="goToRoute(' + data.id + ')">View Route</div>',
					});	
		        });
		    },

		    savePhysiciansThenRoute() {
		    	this.in_progress = true;
		    	axios.post('/api/physicians/store_multiple', this.route_stops.slice(0,25)).then(({ data }) => { 
					//data is a the new physician objects. all we need are the new location IDs
					this.form.locations = data.map(physician => physician.location_primary.id);
					this.submitRoute();
					this.in_progress = false;
				});
		    },

		},

		computed: {
			...mapGetters(['mappableProviderIds']),
			...mapState(['config', 'options', 'perms', 'user']),
		},

		watch: {
			newRouteEndObject() {
				this.form.route_end = this.newRouteEndObject.id ? this.newRouteEndObject.id : -1;
				this.form.route_end_other = this.newRouteEndObject.label ? this.newRouteEndObject.label : this.newRouteEndObject;
			},

			newRouteStartObject() {
				this.form.route_start = this.newRouteStartObject.id ? this.newRouteStartObject.id : -1;
				this.form.route_start_other = this.newRouteStartObject.label ? this.newRouteStartObject.label : this.newRouteStartObject;
			},
		},

	}

</script>

<style scoped>
	.button-wrap {
		border-top:1px solid #e4e7ea;
		margin:0 -1rem; }

	.route-stops {
		box-shadow:inset 0px 7px 9px -7px rgba(0,0,0,0.4);
	}

	i.refresh { 
		cursor:pointer !important;
	}

	@media (min-width: 576px) { 
		.route-stops {
			box-shadow:inset 7px 0 9px -7px rgba(0,0,0,0.4);
		}
	}
</style>